import Player from '@vimeo/player';

export default {
  init() {
  },
  finalize() {
    const $bannerVideoWrap = $('.banner-video-wrap');
    if ($bannerVideoWrap.length > 0) {
      const vimeoPlayer = new Player('banner-video', {
        id: $('#banner-video').data('banner-vimeo-id'),
        controls: false,
        loop: true,
        autoplay: true,
        background: true,
        byline: false,
        autopause: false,
        responsive: true,
        muted: true,
        title: false,
        portrait: false,
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/banner.js